import ContactInfoPanel from "@/components/contact/ContactInfoPanel";
import ContactForm from "@/components/contact/ContactForm";
import ContactMap from "@/components/contact/ContactMap";

export default function Contactos() {
  return (
    <div data-testid="contactos-page">
      <section className="relative bg-[#0a0a0a] text-white overflow-hidden">
        <div className="grain absolute inset-0" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32">
          <div className="overline mb-4">Fale Connosco</div>
          <h1 className="font-display font-black uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-4xl">
            Vamos fixar<br />o seu <span className="text-[#1FA8E0]">próximo projeto</span>.
          </h1>
          <p className="mt-6 text-white/70 max-w-2xl text-lg">
            A nossa equipa está disponível para o ajudar a encontrar a solução ideal.
          </p>
        </div>
      </section>

      <section className="bg-white py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-8 md:gap-12">
          <ContactInfoPanel />
          <ContactForm />
        </div>
      </section>

      <ContactMap />
    </div>
  );
}
